var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMagDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.259 26.9048H10.0583C4.86475 26.9048 0.858453 23.4546 1.54549 19.5721L4.54055 6.38333C5.24692 3.27314 8.82167 1 13.004 1H39.3112C43.4957 1 47.0704 3.27314 47.7768 6.38333L50.7719 19.5721C51.4589 23.4546 47.4548 26.9048 42.259 26.9048Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8491 20.4287V28.5239C50.8491 32.1004 47.0038 35.0001 42.2611 35.0001H10.0561C5.31341 35.0001 1.46814 32.1004 1.46814 28.5239V20.4287",
    stroke: "#0E0E0E",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 31,
    r: 1,
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagDark);
export default __webpack_public_path__ + "static/media/icon-mag-dark.e94c91957785007c3875bb72f48b1eb4.svg";
export { ForwardRef as ReactComponent };